export enum ConsentStatus {
    OptIn = "Opt In",
    OptOut = "Opt Out",
}

// The Salesforce Interactions SDK only defines one consent purpose constant
// (`SalesforceInteractions.ConsentPurpose.Tracking`). Sending a purpose it
// doesn't recognize makes the SDK silently discard the whole consent update
// (its internal store never registers the opt-in), so no telemetry is ever
// sent even though the beacon script loads normally.
export enum ConsentPurpose {
    Tracking = "Tracking", // Core behavior tracking — the only purpose the Salesforce Interactions SDK recognizes
}

export interface ConsentObject {
    provider: string;
    purpose: string;
    status: ConsentStatus;
}

export type ConsentState = "granted" | "denied" | "pending";
